/**
 * Formats a stored direction for display, optionally remapping to In/Out.
 *
 * @param {string} direction
 *   Stored direction key (e.g. Northbound).
 * @param {Record<string, string>} [labelMap]
 *   Optional map of stored direction => display label.
 * @returns {string}
 */
export function formatDirectionLabel(direction, labelMap = {}) {
  if (!direction) {
    return direction;
  }
  if (labelMap && labelMap[direction]) {
    return labelMap[direction];
  }
  // Schedule API sometimes returns lowercase cardinals.
  const normalized =
    direction.charAt(0).toUpperCase() + direction.slice(1).toLowerCase();
  if (labelMap && labelMap[normalized]) {
    return labelMap[normalized];
  }
  if (direction === "westbound") {
    return "Westbound";
  }
  if (direction === "eastbound") {
    return "Eastbound";
  }
  return normalized === direction ? direction : normalized;
}

/**
 * Preferred order for direction tabs (unknown directions sort to the end).
 */
export const DIRECTION_ORDER = [
  "Northbound",
  "Southbound",
  "Eastbound",
  "Westbound",
  "Inbound",
  "Outbound",
];

/**
 * Sorts direction keys by stored cardinal order (Northbound before Southbound).
 * Display-label remapping does not change tab order.
 *
 * @param {string[]} directions
 * @returns {string[]}
 */
export function sortDirections(directions) {
  return [...directions].sort((a, b) => {
    const normalizedA =
      a.charAt(0).toUpperCase() + a.slice(1).toLowerCase();
    const normalizedB =
      b.charAt(0).toUpperCase() + b.slice(1).toLowerCase();
    const indexA = DIRECTION_ORDER.indexOf(normalizedA);
    const indexB = DIRECTION_ORDER.indexOf(normalizedB);
    const orderA = indexA === -1 ? DIRECTION_ORDER.length : indexA;
    const orderB = indexB === -1 ? DIRECTION_ORDER.length : indexB;
    return orderA - orderB || normalizedA.localeCompare(normalizedB);
  });
}
